import React from 'react';
import { Box, Typography, Link, Card, CardContent, Stack } from '@mui/material';

interface TrainingItem {
  href: string;
  label: string;
  description?: string;
}

const ANNUAL_REPORTS_TRAININGS: TrainingItem[] = [
  {
    href: 'https://peo-portal.com/training/cee801bd33e7409295aa3364ccc89440',
    label: 'Annual Reports: Completing the Roster and Dues Form',
    description:
      'This training video demonstrates the process of completing the Roster and Dues form for both local chapter treasurers and presidents.',
  },
  {
    href: 'https://peo-portal.com/training/60513fcf53f049eebe0d2170d6e625d3',
    label: 'Annual Reports: IRS-LC Preparation',
    description:
      'This training video demonstrates the process of preparing to complete the IRS-LC form for local chapter treasurers. It shows both the paper ledger and P.E.O. treasurer Excel File. Only U.S. chapters need to complete the IRS-LC.',
  },
  {
    href: 'https://peo-portal.com/training/e348e797a59a4371a7a6d34c00596c59',
    label: 'Annual Reports: Completing the IRS-LC',
    description:
      'This training video demonstrates the process of completing the IRS-LC form for both local chapter treasurers and presidents. Only U.S. chapters need to complete the IRS-LC.',
  },
  {
    href: 'https://peo-portal.com/training/c1c71fed76b94d6db5340123aec1b5bf',
    label: 'Annual Reports: IRS-LC Reconciliation',
  },
  {
    href: 'https://peo-portal.com/training/639e3c2b30fa47538e04c63318f4363f',
    label: 'Annual Reports: Roster and Dues for S/P/D Officers',
  },
  {
    href: 'https://peo-portal.com/training/9f8a9a1a69ae43d3bb018928ddd92c84',
    label: 'Annual Reports: Reassignment of Local Chapter Officers',
    description:
      'This training video demonstrates the process of assigning a new local chapter officer, a s/p/d treasurer (executive assistant) or president to an annual report role. Only s/p/d officers, executive assistants or Executive Office staff can do this.',
  },
  {
    href: 'https://peo-portal.com/training/12a544d683854af98ffda027fbdd62d8',
    label: 'Annual Reports Training Webinar for S/P/D Officers',
  },
];

const Training: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Annual Reports Training
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Shortcuts to training videos for the annual reports process.
      </Typography>

      <Card sx={{ maxWidth: 640 }}>
        <CardContent>
          <Stack spacing={2}>
            {ANNUAL_REPORTS_TRAININGS.map((item) => (
              <Box key={item.href}>
                <Link
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body1"
                >
                  {item.label}
                </Link>
                {item.description && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    {item.description}
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Training;
